import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as r } from "../chunks/tslib.es6.js";
import t from "./Accessor.js";
import { ReadOnlyMultiOriginJSONMixin as s } from "./ReadOnlyMultiOriginJSONSupport.js";
import { nameToId as e, OriginIdNum as o } from "./accessorSupport/PropertyOrigin.js";
import { getProperties as i } from "./accessorSupport/utils.js";
import { write as c } from "./accessorSupport/write.js";
import { subclass as n } from "./accessorSupport/decorators/subclass.js";

var p = function p(t) {
  var s = /*#__PURE__*/function (_t) {
    _inherits(s, _t);

    var _super = _createSuper(s);

    function s() {
      _classCallCheck(this, s);

      for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
        r[_key] = arguments[_key];
      }

      return _super.call.apply(_super, [this].concat(r));
    }

    _createClass(s, [{
      key: "clear",
      value: function clear(r) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "user";
        return u(this).delete(r, e(t));
      }
    }, {
      key: "write",
      value: function write() {
        var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var t = arguments.length > 1 ? arguments[1] : undefined;
        return c(this, r = r || {}, t), r;
      }
    }, {
      key: "setAtOrigin",
      value: function setAtOrigin(r, t, _s) {
        i(this).setAtOrigin(r, t, e(_s));
      }
    }, {
      key: "removeOrigin",
      value: function removeOrigin(r) {
        var t = u(this),
            _s2 = e(r),
            o = t.keys(_s2);

        var _iterator = _createForOfIteratorHelper(o),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _e = _step.value;
            t.originOf(_e) === _s2 && t.set(_e, t.get(_e, _s2), 6);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }, {
      key: "updateOrigin",
      value: function updateOrigin(r, t) {
        var _s3 = u(this),
            i = e(t),
            c = this.get(r);

        for (var _e2 = i + 1; _e2 < o; ++_e2) {
          _s3.delete(r, _e2);
        }

        _s3.set(r, c, i);
      }
    }, {
      key: "toJSON",
      value: function toJSON(r) {
        return this.write({}, r);
      }
    }]);

    return s;
  }(t);

  return s = r([n("esri.core.WriteableMultiOriginJSONSupport")], s), s.prototype.toJSON.isDefaultToJSON = !0, s;
};

function u(r) {
  return i(r).store;
}

var l = function l(t) {
  var e = /*#__PURE__*/function (_p) {
    _inherits(e, _p);

    var _super2 = _createSuper(e);

    function e() {
      _classCallCheck(this, e);

      for (var _len2 = arguments.length, r = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        r[_key2] = arguments[_key2];
      }

      return _super2.call.apply(_super2, [this].concat(r));
    }

    return e;
  }(p(s(t)));

  return e = r([n("esri.core.MultiOriginJSONSupport")], e), e;
};

var O = /*#__PURE__*/function (_l) {
  _inherits(O, _l);

  var _super3 = _createSuper(O);

  function O() {
    _classCallCheck(this, O);

    return _super3.apply(this, arguments);
  }

  return O;
}(l(t));

O = r([n("esri.core.MultiOriginJSONSupport")], O);
export { l as MultiOriginJSONMixin, O as MultiOriginJSONSupport };